/**
 * Local Design Tokens
 *
 * Simplified EITELKEIT tokens for standalone deployment.
 * Based on Berghain Terminal aesthetic (Toxic Mint on Void Black).
 */

export const tokens = {
  colors: {
    void: '#0a0a0a',
    surface: '#1a1a1a',
    border: '#2a2a2a',
    mint: '#00ff87',
    mintDim: 'rgba(0, 255, 135, 0.3)',
    textPrimary: '#ffffff',
    textMuted: '#888888',
    danger: '#ff4757',
    warning: '#ffa502',
    success: '#00ff87',
    info: '#3b82f6',
  },
  fonts: {
    mono: '"JetBrains Mono", "Fira Code", monospace',
    sans: '"Inter", system-ui, sans-serif',
  },
  fontSizes: {
    xs: '11px',
    sm: '13px',
    base: '15px',
    lg: '17px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    0: '0',
    1: '4px',
    2: '8px',
    3: '12px',
    4: '16px',
    5: '20px',
    6: '24px',
    8: '32px',
    10: '40px',
  },
  radii: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px',
  },
};
